import React from 'react';
import { Form, Switch, Input, Select, Row, Col, Button } from 'antd';
import { getRolesList } from '../../modules/Api';
import { translateRoles } from './pipeline';
import history from '../../modules/History';

const FormItem = Form.Item;
const Option = Select.Option;

function hasErrors(fieldsError) {
    return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class CouponForm extends React.Component {
    constructor() {
        super();
        this.state = {
            roles: [],
            loading: false,
        }
    }

    componentDidMount() {
        getRolesList(res => {this.setState({roles: translateRoles(res)})});
    }

    componentWillReceiveProps(nextProps) {

    }

    handleSubmit = e => {
        e.preventDefault();

        this.props.form.validateFields((err, fieldsValue) => {
            if (err) {
                return;
            }
            this.props.submit(Object.assign({}, fieldsValue));
        })
    }

    render() {

        const formItemLayout = {
            labelCol: {
            xs: { span: 24 },
            sm: { span: 24 },
            },
            wrapperCol: {
            xs: { span: 24 },
            sm: { span: 24 },
            },
        };
        const { getFieldDecorator, getFieldsError } = this.props.form;
        return (
            <div style={{direction: 'rtl'}}>
            <Form onSubmit={this.handleSubmit}>
                <Row>
                    <Col span={10} offset={1}>
                        <FormItem
                        {...formItemLayout}
                        label="نقش"
                        colon={false}>
                            {getFieldDecorator('role_id', {
                                initialValue: this.props.initialData.role_id,
                                rules: [
                                { required: true, message: 'نقش را انتخاب نمایید' },
                                ],
                            })(
                                <Select filterOption={false} mode="combobox" placeholder="انتخاب نقش" style={{width: '200px'}}>
                                    {this.state.roles.map(r => <Option value={r.id.toString()} key={`ss__${r.id}`}>{r.title}</Option>)}
                                </Select>
                            )}
                        </FormItem>

                        <FormItem
                        {...formItemLayout}
                        label="شماره موبایل تایید شده است؟"
                        colon={false}>
                        {getFieldDecorator('confirmed_phone', { valuePropName: 'checked', initialValue: this.props.initialData.status === 1, })(
                            <Switch checkedChildren="بله" unCheckedChildren="خیر"/>
                        )}
                        </FormItem>


                    </Col>

                    <Col span={11} offset={1}>
                    <FormItem
                        {...formItemLayout}
                        label="نام"
                        colon={false}>
                        {getFieldDecorator('first_name', {
                            initialValue: this.props.initialData.first_name,
                            rules: [{
                            required: true, message: 'نام کاربر را وارد نمایید!',
                            }],
                        })(
                            <Input />
                        )}
                    </FormItem>

                    <FormItem
                        {...formItemLayout}
                        label="نام خانوادگی"
                        colon={false}>
                        {getFieldDecorator('last_name', {
                            initialValue: this.props.initialData.last_name,
                            rules: [{
                            required: true, message: 'نام خانوادگی کاربر را وارد نمایید!',
                            }],
                        })(
                            <Input/>
                        )}
                    </FormItem>

                    <FormItem
                        {...formItemLayout}
                        label="ایمیل"
                        colon={false}>
                        {getFieldDecorator('email', {
                            initialValue: this.props.initialData.email,
                            rules: [{
                            required: true, message: 'ایمیل کاربر را وارد نمایید!',
                            }],
                        })(
                            <Input />
                        )}
                    </FormItem>

                    <FormItem
                        {...formItemLayout}
                        label="شماره موبایل"
                        colon={false}>
                        {getFieldDecorator('phone', {
                            initialValue: this.props.initialData.phone,
                            rules: [{
                                required: true, message: 'شماره موبایل کاربر را وارد نمایید!',
                            }],
                        })(
                            <Input />
                        )}
                    </FormItem>

                    <FormItem
                        {...formItemLayout}
                        label="رمز عبور"
                        colon={false}>
                        {getFieldDecorator('password', {
                            initialValue: '',
                            rules: [{

                            }],
                        })(
                            <Input type="password" autocomplete="new-password" />
                        )}
                    </FormItem>

                    </Col>


                </Row>
                <FormItem>
                    <div className="btn-container">
                        <Button
                            type="primary"
                            htmlType="submit"
                            disabled={hasErrors(getFieldsError()) || this.props.submitted}
                        >
{this.props.submitted ? 'منتظر بمانید' : ' ثبت'}
                        </Button>

                        {
                            this.props.initialData.id &&
                            <Button type="secondary" onClick={() => history.item.push(`/history/user/${this.props.initialData.id}`)}>تاریخچه تغییرات</Button>
                        }
                    </div>
                </FormItem>
            </Form>
        </div>
        )
    }
}
CouponForm.defaultValue = {
    initialData: {}
}

export default Form.create()(CouponForm);


// WEBPACK FOOTER //
// ./src/containers/Users/form.js